import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLockFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		transform: "scale(1.5)",
		children: /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.00905 1.33467C9.95571 1.33467 11.541 2.92001 11.541 4.86867L11.541 5.91974C12.7244 6.33161 13.5758 7.45828 13.5758 8.78054V11.6399C13.5758 13.3099 12.2178 14.6679 10.5478 14.6679H5.45378C3.78378 14.6679 2.42578 13.3099 2.42578 11.6399V8.78054C2.42578 7.45853 3.2768 6.33204 4.45992 5.91997L4.46038 4.86867C4.46438 3.90867 4.83571 3.02267 5.50571 2.35867C6.17638 1.69401 7.06171 1.30934 8.00905 1.33467ZM8.00065 8.96974C8.27665 8.96974 8.50065 9.19374 8.50065 9.46974V10.9504C8.50065 11.2264 8.27665 11.4504 8.00065 11.4504C7.72465 11.4504 7.50065 11.2264 7.50065 10.9504V9.46974C7.50065 9.19374 7.72465 8.96974 8.00065 8.96974ZM8.00705 2.33467H7.99638C7.32105 2.33467 6.68838 2.59467 6.21038 3.06867C5.72905 3.54467 5.46305 4.18001 5.46038 4.85734L5.45978 5.75216H10.5404L10.541 4.86867C10.541 3.47134 9.40438 2.33467 8.00705 2.33467Z",
			fill: "currentColor"
		})
	})
});
export default SvgLockFill;
